'use client'

type CurrencyCode = 'USD'

type UABaseParams = {
  user_id?: string | null
  user_name?: string | null
  description?: string | null
}

type UAPurchaseParams = UABaseParams & {
  price: number
  currency: CurrencyCode
  order_id?: string
  content_id?: string
  item_quantity?: number
}

type UASignUpParams = UABaseParams
type UASignInParams = UABaseParams
type UAContentViewParams = UABaseParams & { content_id?: string }
type UAScheduleAppointmentParams = UABaseParams
type UASubscribeParams = UABaseParams & { price: number; currency: CurrencyCode }
type UACustomParams = UAPurchaseParams

export type UAEventName =
  | 'purchase'
  | 'sign_up'
  | 'sign_in'
  | 'content_view'
  | 'schedule_appointment'
  | 'subscribe'
  | 'custom_event_1'
  | 'custom_event_2'

type UAParamsByEvent = {
  purchase: UAPurchaseParams
  sign_up: UASignUpParams
  sign_in: UASignInParams
  content_view: UAContentViewParams
  schedule_appointment: UAScheduleAppointmentParams
  subscribe: UASubscribeParams
  custom_event_1: UACustomParams
  custom_event_2: UACustomParams
}

declare global {
  interface Window {
    uapx?: {
      sendConversion: (event: string, params: Record<string, unknown>) => void
    }
  }
}

export function sendUAConversion<E extends UAEventName>(event: E, params: UAParamsByEvent[E]): void {
  if (typeof window === 'undefined') return
  if (typeof window.uapx?.sendConversion !== 'function') {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[ua] window.uapx.sendConversion not available; skipping', event, params)
    }
    return
  }
  try {
    window.uapx.sendConversion(event, params as Record<string, unknown>)
  } catch (e) {
    console.warn('[ua] sendConversion threw; ignoring', e)
  }
}
